import { html } from 'lit-html';
import { sRender } from '../../../utils/render';
import { getState, getSubscriber } from '../../../utils/state';
import ComparativeTemporalChart from './analysis-comp-temp-chart';
import CompositionChart from './analysis-compo-chart';
import GeoChart from './analysis-geo-chart';
import { render } from 'lit-html';
import AnalysisTitle from '../analysis-title';

const AnalysisChart = (info) => {
  const { analysis } = getState();

  getSubscriber(() => {
    const { analysis } = getState();
    let url = new URL(window.location.href);
    if (!url.searchParams.has('geoids') && analysis.geoids != null) {
      url.searchParams.set('geoids', analysis.geoids);
      history.replaceState(null, '', url.toString());
      let selectedGeo = analysis.geoids;
      let geoName = info.indicator?.geos.find(
        (el) => el.geo_id == selectedGeo
      )?.geo_name;
      geoName = geoName ? geoName : '';
      render(
        AnalysisTitle(`${info.indicator.name} ${geoName}`),
        document.getElementById('analysis-info-title')
      );
    }
    sRender(ChartLogic, 'analysis-chart', analysis, info);
  });

  return html`<div id="analysis-chart">${ChartLogic(analysis, info)}</div> `;
};

export function ChartLogic(analysis = {}, info) {
  if (analysis.tabSelected) {
    // 0 - Comparative, 1 - Temporal, 2 - Composition, 3 - Geo
    const view = analysis.tabSelected.label;
    const components = {
      comparative: ComparativeTemporalChart,
      temporal: ComparativeTemporalChart,
      composition: CompositionChart,
      geographical: GeoChart,
    };

    return html`<section class="esios-analysis__info-chart-section">
      ${components[view](analysis, info)}
    </section>`;
  }

  return html` <div>Loading</div> `;
}
export default AnalysisChart;
